// CloudKeeper Org Services Portal — StackSets API client.
// Uses portalFetch from portalApi.js (JWT stored as portal_token).
import { portalFetch } from './portalApi';

// --- service config ---
export const getStackSetsConfig = () => portalFetch('/api/v1/stacksets/config');

export const enableStackSets = (adminAccountId) =>
  portalFetch('/api/v1/stacksets/config', {
    method: 'POST',
    body: JSON.stringify({ adminAccountId }),
  });

export const disableStackSets = (deleteTemplateBucket) =>
  portalFetch('/api/v1/stacksets/config', {
    method: 'DELETE',
    body: JSON.stringify({ deleteTemplateBucket: !!deleteTemplateBucket }),
  });

export const listStackSetsAccounts = () => portalFetch('/api/v1/stacksets/accounts');
export const getStackSetsOrgTree = () => portalFetch('/api/v1/stacksets/org-tree');
export const listRoleStatuses = () => portalFetch('/api/v1/stacksets/roles');

export const retryRole = (accountId) =>
  portalFetch('/api/v1/stacksets/roles/retry', {
    method: 'POST',
    body: JSON.stringify({ accountId }),
  });

// validateTemplate validates a pasted/uploaded body OR a customer-owned S3 URL
// (pass one or the other). The response echoes the normalized https URL.
export const validateTemplate = (templateBody, templateS3Url = '') =>
  portalFetch('/api/v1/stacksets/validate-template', {
    method: 'POST',
    body: JSON.stringify({ templateBody, templateS3Url }),
  });

// --- stacksets ---
export const listStackSets = () => portalFetch('/api/v1/stacksets/stacksets');

export const createStackSet = (body) =>
  portalFetch('/api/v1/stacksets/stacksets', {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const getStackSet = (id) =>
  portalFetch(`/api/v1/stacksets/stacksets/${encodeURIComponent(id)}`);

export const updateStackSet = (id, body) =>
  portalFetch(`/api/v1/stacksets/stacksets/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });

export const deleteStackSet = (id, retainStacks) =>
  portalFetch(`/api/v1/stacksets/stacksets/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    body: JSON.stringify({ retainStacks: !!retainStacks }),
  });

export const getStackSetTemplate = (id) =>
  portalFetch(`/api/v1/stacksets/stacksets/${encodeURIComponent(id)}/template`);

export const listInstances = (id) =>
  portalFetch(`/api/v1/stacksets/stacksets/${encodeURIComponent(id)}/instances`);

export const retryInstances = (id, accounts = [], regions = []) =>
  portalFetch(`/api/v1/stacksets/stacksets/${encodeURIComponent(id)}/instances/retry`, {
    method: 'POST',
    body: JSON.stringify({ accounts, regions }),
  });

// listInstanceEvents returns the member-account CloudFormation stack's
// resource-level events for one instance (the AWS "Events" tab).
export const listInstanceEvents = (id, account, region) =>
  portalFetch(
    `/api/v1/stacksets/stacksets/${encodeURIComponent(id)}/instances/${encodeURIComponent(account)}/${encodeURIComponent(region)}/events`,
  );

export const syncStackSet = (id, { dryRun = false, retainStacks = false } = {}) =>
  portalFetch(`/api/v1/stacksets/stacksets/${encodeURIComponent(id)}/sync`, {
    method: 'POST',
    body: JSON.stringify({ dryRun, retainStacks }),
  });

export const listOperations = (id) =>
  portalFetch(`/api/v1/stacksets/stacksets/${encodeURIComponent(id)}/operations`);

export const stopOperation = (id, opId) =>
  portalFetch(`/api/v1/stacksets/stacksets/${encodeURIComponent(id)}/operations/${encodeURIComponent(opId)}/stop`, {
    method: 'POST',
  });
